import { render, staticRenderFns } from "./AssetNavigation.vue?vue&type=template&id=98b03cc4"
import script from "./AssetNavigation.vue?vue&type=script&lang=js"
export * from "./AssetNavigation.vue?vue&type=script&lang=js"
import style0 from "./AssetNavigation.vue?vue&type=style&index=0&id=98b03cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports